import * as React from "react";
import { useMe } from "../../../users/meHooks.ts";
import { routes } from "../../../routing/router.ts";
import { useCommonDialogs } from "../../CommonDialogsProvider.tsx";
import { onNavClick, searchNavItem, sidebarFooterItems, sidebarNavItems } from "../nav.tsx";
import { SideNavItem } from "./SideNavItem.tsx";

export const SideNav: React.FC = () => {
  const me = useMe();
  const commonDialogs = useCommonDialogs();

  return (
    <nav className="sidebar" aria-label="Main">
      <a className="sidebar-brand" {...routes.stash().link}>
        <img src="/logo.webp" alt="" />
        StashIt
      </a>
      <button
        type="button"
        className="sidebar-search"
        onClick={onNavClick(searchNavItem, commonDialogs)}
      >
        {searchNavItem.icon}
        Search
        <span className="kbd">{searchNavItem.keyboardShortcutHint}</span>
      </button>
      {sidebarNavItems.map((item) => (
        <SideNavItem key={item.label} item={item} />
      ))}
      <div className="sidebar-spacer" />
      {sidebarFooterItems.map((item) => (
        <SideNavItem key={item.label} item={item} />
      ))}
      {me?.email && <div className="sidebar-me">{me.email}</div>}
    </nav>
  );
};
